
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntraIdAuthService } from 'src/app/services/entra-id/entra-id-auth.service';
import { LoggerService } from 'src/app/services/logger.service';
import { LoginFederado } from 'src/app/models/callback/LoginFederado';
import { AutenticadorService } from 'src/app/services/autenticador/autenticador.service'


@Component({
  selector: 'app-auth-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'] 
})

export class AuthCallbackComponent implements OnInit {

  private readonly MSG_CRED = 'Hay problemas con el ingreso de su usuario o clave';
  private readonly MSG_UPSTREAM = 'En este momento no podemos atender su solicitud, inténtelo más tarde';
  private readonly MSG_ACCESS = 'Su usuario presenta problemas de acceso';
  preLogin;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private entraSvc: EntraIdAuthService,
    private logger: LoggerService,
    private autenticatorService: AutenticadorService,
    @Inject('env') private environment: any
  ) {this.preLogin = JSON.parse(sessionStorage.getItem('preLogin'));}

  
  
  private msgFromCodret(codret: any): string {
    var c = codret;
    if (c === null || c === undefined) {
      c = '';
    }

    if (c === '-1') { return this.MSG_CRED; }      // credenciales/token inválidos
    if (c === '-4') { return this.MSG_UPSTREAM; }  // comunicación con tercero/Entra
    if (c === '-5') { return this.MSG_ACCESS; }    // perfil no activo/no registrado

    return this.MSG_UPSTREAM; 
  }

  
  private setErrorAndGoLogin(msg: string) {
    sessionStorage.setItem('callbackError', msg);
    this.entraSvc.clearPkce();
    this.router.navigate(['/login'], { replaceUrl: true });
  }


  async ngOnInit() {

    const params = this.route.snapshot.queryParamMap;
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');
    const errorDescription = params.get('error_description');
    this.logger.log('AuthCallback: query params recibidos');
    

    if (error) {
      this.logger.error('AuthCallback: error recibido de Entra ID', {
        error: error,
        errorDescription: errorDescription
      });
      

      var msg = this.MSG_CRED;
      if (error === 'temporarily_unavailable' || error === 'server_error') {
        msg = this.MSG_UPSTREAM;
      }

      this.setErrorAndGoLogin(msg);
      return;


    }

    const storedPkce = this.entraSvc.getStoredPkce();
    const codeVerifier = storedPkce ? storedPkce.codeVerifier : undefined;
    const storedState = storedPkce ? storedPkce.state : undefined;
    const nonce = storedPkce ? storedPkce.nonce : undefined;

    const invalid =
      !code ||
      !state ||
      !storedState ||
      state !== storedState ||
      !codeVerifier ||
      !nonce;

    if (invalid) {
      this.setErrorAndGoLogin(this.MSG_UPSTREAM);
      return;
    }

    const safeCode: string = code as string;
    const safeCodeVerifier: string = codeVerifier as string;
    const safeNonce: string = nonce as string;
    const safeState: string | null = state;


    try {
      const body = new LoginFederado();
      body.code = safeCode;
      body.codeVerifier = safeCodeVerifier;
      body.nonce = safeNonce;
      body.state = safeState !== null ? safeState : undefined; 
      
      body.docEmpresa = this.environment.docEmpresa;
      body.codCliente = this.environment.codCliente;
      body.codTpoPortal = this.preLogin.codTpoPortal;

      const resp: any = await this.autenticatorService.loginFederado(body).toPromise();


      if (resp && resp.codret === '0') {

        sessionStorage.setItem('userPerfil', JSON.stringify(resp));

        const docUsuario = (resp && resp.usuario && resp.usuario.docUsuario != null)
          ? resp.usuario.docUsuario
          : '';
        sessionStorage.setItem('docUsuario', docUsuario);

        const idPerfil = (resp && resp.perfil && resp.perfil.idPerfil != null)
          ? resp.perfil.idPerfil
          : '';
        sessionStorage.setItem('idPerfil', idPerfil);

        const currentUser = (resp && resp.usuario != null) ? resp.usuario : {};
        sessionStorage.setItem('currentUser', JSON.stringify(currentUser));

        const tokenSession = (resp && resp.tokenSession != null) ? resp.tokenSession : '';
        sessionStorage.setItem('tokenSession', tokenSession);

        const minExpSession = (resp && resp.perfil && resp.perfil.polMinExpSesion != null)
          ? resp.perfil.polMinExpSesion
          : '';
        sessionStorage.setItem('minExpSession', minExpSession);

        let urlMenu = '';
        if (resp && resp.perfil && resp.perfil.modulos && resp.perfil.modulos.length > 0) {
          const firstModulo = resp.perfil.modulos[0];
          urlMenu = (firstModulo && firstModulo.url != null) ? firstModulo.url : '';
        }

        if (!tokenSession || !urlMenu) {
          this.logger.error('AuthCallback: respuesta inconsistente tras codret=0', {
            hasToken: !!tokenSession,
            urlMenu: urlMenu
          });

          this.setErrorAndGoLogin(this.MSG_UPSTREAM);
          return;
        }

        
        this.entraSvc.clearPkce();
        this.router.navigate(['/home', urlMenu], { replaceUrl: true });

      } else {
        this.logger.error('AuthCallback: loginFederado retornó error de negocio', {
          codret: resp ? resp.codret : undefined,
          descret: resp ? resp.descret : undefined,
          codError: resp ? resp.codError : undefined
        });

        this.setErrorAndGoLogin(this.msgFromCodret(resp ? resp.codret : null));
        return;

      }
    } catch (e) { 
      const err = e as any; 

      this.logger.error('[AuthCallback] intercambio de code falló', {
        message: err && err.message ? err.message : undefined,
        name: err && err.name ? err.name : undefined,
        stack: err && err.stack ? err.stack : undefined,
        status: err && err.status ? err.status : undefined,
        statusText: err && err.statusText ? err.statusText : undefined
      });
      this.setErrorAndGoLogin(this.MSG_UPSTREAM);
      return;

    }
  }



}
